export const SAVE_OBSERVATION = 'SAVE_OBSERVATION'
export const FETCH_OBSERVATIONS = 'FETCH_OBSERVATIONS'
export const CREATE_OBSERVATION = 'CREATE_OBSERVATION'
export const GET_SINGLE_OBSERVATION = 'GET_SINGLE_OBSERVATION'
export const GET_OBSERVATION_COMMENTS = 'GET_OBSERVATION_COMMENTS'
export const CREATE_OBSERVATION_COMMENT = 'CREATE_OBSERVATION_COMMENT'
export const DELETE_OBSERVATION_COMMENT = 'DELETE_OBSERVATION_COMMENT'
export const GET_OBSERVEE_SUBJECTS = 'GET_OBSERVEE_SUBJECTS'
export const EDIT_OBSERVATION = 'EDIT_OBSERVATION'
export const DELETE_SINGLE_OBSERVATION = 'DELETE_SINGLE_OBSERVATION'
export const DELETE_MANY_OBSERVATION = 'DELETE_MANY_OBSERVATION'
